module.exports = __webpack_public_path__ + "static/media/psu-profile.063323d5.png";